import apiUrl from '../../../../constants'
import axios from 'axios'
import Paginate from 'vuejs-paginate'
import {
	Validator
} from 'vee-validate'
import moment from 'moment'

import DatePicker from 'vue2-datepicker'
import CryptoJS from 'crypto-js'
import download from 'downloadjs';
import Loader from './../../shared/loader'
import Pagination from './../../shared/pagination'
import csvHelper from '../importjsontocsv';
import Vue from "vue";
import JsonExcel from "vue-json-excel";

import {
	BasicSelect
} from 'vue-search-select'
import 'vue-search-select/dist/VueSearchSelect.css'
Vue.component("downloadExcel", JsonExcel);

export default {
	name: 'order',
	components: {
		Paginate,
		Pagination,
		JsonExcel,
		DatePicker,
		Loader,
		BasicSelect
	},
	data() {
		return {
			// currentPage: 0,
			mid: '',
			isLoadingforxls: false,
			csvFieldsForXls: {},
			listReportDataforxls: [],
			totalPage: 0,
			totalRows: 0,
			currentPage: 1,
			pageLimit: 10,
			listOrderReportData: {
				ordercount: 0,
				totalsku: 0,
				totalquantity: 0,
				result: [],
			},
			movenoFlt: "",
			fromDateFlt: '',
			fromDateFltShip: "",
			toDateFltShip: "",
			// perPage: 10,
			// totalPage: 0,
			// pageNo: 0,
			orderStatus: '',
			isLoading: false,
			listClientData: [],
			listWarehouseData: [],
			totalrowsData: [],
			listOrderReportDataCsv: [],

			ClientErr: '',
			WarehouseErr: '',
			showSelectWarehouse: false,
			showSelectClient: false,
			showSelectMerchant: false,

			clientid: '',
			client: '',
			warehouseid: '',
			warehouse: '',

			//checkStatus: 0,
			searchchannel: '',


			channellist: [],
			showOrderAllocationRacks: false,
			allocationResultData: [],
			formattedDate: '',
			racktype: '',
			ordersubtype: '',
			user_type: '',
			userid: '',
			show: false,
			download: true,
			dataFilter2: '',
			reportname: '',
			recordLimit: 0,
			limitExeed: false,
			listMerchantData: [],
			merchant: '',
			toDateFlt: '',
			currentDate: '',
			item: {
				value: '',
				text: ''
			},
			listMerchantData1: [{
				value: '',
				text: this.$t('common.selectMerchantPlaceHolder')
			}],

			// totalRows:0,
		}
	},
	model: {
		totalqty: 0
	},
	computed: {},
	filters: {

		moment: function (date) {
			if (date != null)
				return moment(date).format('DD-MM-YYYY');
		},
		momentDateTime: function (date) {
			if (date != null)
				return moment(date).format('DD-MM-YYYY HH:mm:ss');
		}
	},
	mounted() {
		var permissionEncrypt = window.localStorage.getItem('userdetail')
		var bytes = CryptoJS.AES.decrypt(permissionEncrypt.toString(), 'Key');
		var plaintext = bytes.toString(CryptoJS.enc.Utf8);
		var userdetail = JSON.parse(plaintext);
		var loginuserid = userdetail.userid;
		var loginuseremail = userdetail.email;
		this.userid = userdetail.userid;
		var today = new Date();
		this.formattedDate = moment(today).format('DD/MM/YYYY HH:mm:ss')
		this.reportname = this.$t('editedjson.moveOrder')
		this.reportname = this.reportname + moment().format('DD-MM-YY_HH-mm-ss') + '.xls';
		this.pageNo = 0;
		this.orderStatus = 'allocated'
		this.warehouse = window.localStorage.getItem('selectedWarehouse')
		this.warehouseid= this.warehouse
		this.clientid =this.client
		if (localStorage.getItem("selectedClient")!=='undefined')
		{
		this.getMerchantList();
		}
		this.user_type = userdetail.utype;

		switch (this.user_type) {
			case 'system_user':
				this.showSelectClient = true;
				this.showSelectWarehouse = true;
				this.showSelectMerchant = true;
				// this.getClientList();
				// this.getWarehouseList();
				break;

			case 'client_user':
				this.clientid = userdetail.clientid;
				this.client = this.clientid;
				this.showSelectWarehouse = true;
				this.showSelectMerchant = true;
				// this.getWarehouseList();
				this.getMerchantList()
				if (userdetail.merchantid) {
					this.mid = userdetail.merchantid.toString()
					this.merchant = this.mid
					this.showSelectMerchant = false;
				}
				break;

			case 'warehouse_user':
				this.loginUserEmail = userdetail.email;
				this.warehouseid = userdetail.warehouseid;
				this.warehouse = this.warehouseid;
				this.showSelectClient = true;
				this.showSelectMerchant = true;
				// this.getClientList();

				var roleids = userdetail.roleid.split(',');
				for (var i = 0; i < roleids.length; i++) {
					if (roleids[i] == 40) {
						this.purchasingManager = parseInt(roleids[i]);
					}
					if (roleids[i] == 41) {
						this.isInwardUserForPO = true;
					}
				}
				break;

			default:
				this.$alertify.error(this.$t('common.unauthorisedError'));
				break
		}
		this.getRecordLimit();
		//this.calldateFunction();
	}, // End computed
	methods: {
		reset() {
			this.item = {}
		},
		onSelect(item) {
			// select option from parent component
			this.item = item
			this.merchant = item.value;

		},
		calldateFunction() {
			//console.log("sagar")
			this.currentDate = new Date().toJSON().slice(0, 10).replace(/-/g, '/');

			var dt = new Date(this.currentDate);
			dt.setDate(dt.getDate() - 6);
			this.toDateFlt = this.currentDate;
			this.fromDateFlt = dt;

		},
		getOrderListSearch(csvCheck) {
			this.currentPage = 1;
			this.getMoveOrderListReport(2);
		},

		getMerchantList() {
			var userToken = window.localStorage.getItem('userToken')
			var myStr = userToken.replace(/"/g, '');
			this.input = ({
				clientid: localStorage.getItem('selectedClient'),
			})
			axios({
				method: 'POST',
				'url': apiUrl.api_url + 'merchantList',
				'data': this.input,
				headers: {
					'Authorization': 'Bearer ' + myStr
				}
			})
				.then(result => {
					if (result.data && result.data.length > 0) {
						this.listMerchantData = result.data;
						var merchantListArray = [];
						result.data.forEach(function (item) {
							merchantListArray[item.merchantid] = item.merchantname;
						});
						this.merchantList = merchantListArray;
						this.item = {
							value: '',
							text: ''
						},
							this.listMerchantData1 = [{
								value: '',
								text: this.$t('common.selectMerchantPlaceHolder')
							}]
						this.listMerchantData.forEach(ele => {
							this.listMerchantData1.push({
								"value": ele.merchantid,
								"text": ele.merchantname

							})
						})

					}
				}, error => {
					console.error(error)
				})
		},


		getRecordLimit() {
			var userToken = window.localStorage.getItem('userToken')
			var myStr = userToken.replace(/"/g, '');
			axios({
				method: 'POST',
				'url': apiUrl.api_url + 'getRecordLimit',
				'data': this.input,
				headers: {
					'Authorization': 'Bearer ' + myStr
				}
			})
				.then(result => {
					if (result.data) {
						this.recordLimit = result.data.data;
					}
				}, error => {
					console.error(error)
				})
		},
		Choosetype1() {
			this.show = true;
			this.download = false;
			if (!this.limitExeed) {
				this.getMoveOrderListReportXLS(3)
			}
		},
		startDownload() {
			this.isLoadingforxls = true;
		},
		finishDownload() {
			this.isLoadingforxls = false;
		},
		Choosetype2() {
			this.show = true;
			this.download = false;
			if (!this.limitExeed) {
				this.getMoveOrderListReportXLS(3)
			}
		},
		Choosetype3() {
			this.show = true;
			this.download = false;
			if (!this.limitExeed) {
				this.getMoveOrderListReportXLS(3)
			}
		},
		dateFormat(date) {
			if (!date) return '';
			return moment(date).format('YYYY-MM-DD');
		},
		dateFormatFRT(date) {
			if (!date) return '';
			return moment(date).format('YYYY-MM-DD HH:mm:ss');
		},
		dateFormat1(date) {
			if (!date) return '';
			return moment(date).format('YYYY-MM-DD') + " 00:00:00";
		},
		dateFormat2(date) {
			if (!date) return '';
			return moment(date).format('YYYY-MM-DD') + " 23:59:59";
		},

		export(data, filename, mime) {
			let blob = this.base64ToBlob(data, mime);
			download(blob, filename, mime);
		},

		base64ToBlob(data, mime) {
			let base64 = window.btoa(window.unescape(encodeURIComponent(data)));
			let bstr = atob(base64);
			let n = bstr.length;
			let u8arr = new Uint8ClampedArray(n);
			while (n--) {
				u8arr[n] = bstr.charCodeAt(n);
			}
			return new Blob([u8arr], {
				type: mime
			})
		},
		// getClientList() {
		// 	this.pageNo = 0;
		// 	if (window.localStorage.getItem("clientList") !== null) {
		// 		var clientListEncrypt = window.localStorage.getItem('clientList');
		// 		var clientbytes = CryptoJS.AES.decrypt(clientListEncrypt.toString(), 'Key');
		// 		var plaintextclient = clientbytes.toString(CryptoJS.enc.Utf8);
		// 		this.listClientData = JSON.parse(plaintextclient);
		// 	} else {
		// 		var userToken = window.localStorage.getItem('userToken');
		// 		var myStr = userToken.replace(/"/g, '');

		// 		this.input = ({
		// 			warehouseid: this.warehouseid,
		// 		});

		// 		axios({
		// 			method: 'POST',
		// 			'url': apiUrl.api_url + 'getWarehouseAssociatedClientList',
		// 			'data': this.input,
		// 			headers: {
		// 				'Authorization': 'Bearer ' + myStr,
		// 			}
		// 		})
		// 			.then(result => {
		// 				this.listClientData = result.data.data;
		// 			}, error => {
		// 				console.error(error);
		// 			});
		// 	}
		// },
		// getWarehouseList() {
		// 	this.pageNo = 0;

		// 	if (window.localStorage.getItem("warehouseList") !== null) {
		// 		var warehouseListEncrypt = window.localStorage.getItem('warehouseList');
		// 		var warehousebytes = CryptoJS.AES.decrypt(warehouseListEncrypt.toString(), 'Key');
		// 		var plaintextwarehouse = warehousebytes.toString(CryptoJS.enc.Utf8);
		// 		this.listWarehouseData = JSON.parse(plaintextwarehouse);
		// 	} else {
		// 		var userToken = window.localStorage.getItem('userToken');
		// 		var myStr = userToken.replace(/"/g, '');
		// 		this.pageNo = 0;
		// 		this.input = ({
		// 			clientid: this.clientid,
		// 		});

		// 		axios({
		// 			method: 'POST',
		// 			'url': apiUrl.api_url + 'getClientAssociatedWarehouseList',
		// 			'data': this.input,
		// 			headers: {
		// 				'Authorization': 'Bearer ' + myStr
		// 			}
		// 		})
		// 			.then(result => {
		// 				// console.log(result.data.data);
		// 				this.listWarehouseData = result.data.data;
		// 			}, error => {
		// 				console.error(error)
		// 			})
		// 	}
		// },

		// clientSelected() {
		// 	if (this.clientid != this.client) {
		// 		this.clientid = this.client;
		// 		this.listMerchantData = [];
		// 		this.merchant = '';
		// 		this.getMerchantList();

		// 		if (this.clientid)
		// 			//this.getSalesChannels();
		// 			if (this.user_type != 'warehouse_user') {
		// 				this.listWarehouseData = [];
		// 				this.getWarehouseList();
		// 				if (this.listWarehouseData.find(entry => entry.warehouseid === this.warehouse)) {
		// 					this.warehouse = this.warehouseid = '';
		// 				} else {
		// 					this.warehouse = '';
		// 				}
		// 			} else {
		// 				if (this.warehouseid && this.clientid) {
		// 					//this.getOrderListReport();
		// 				}
		// 			}
		// 	}
		// 	this.getMerchantList();
		// 	this.listOrderReportData = {
		// 		ordercount: 0,
		// 		totalsku: 0,
		// 		totalquantity: 0,
		// 		result: [],
		// 	};
		// 	this.pageNo = this.totalPage = 0;
		// },

		// warehouseSelected() {
		// 	this.warehouseid = this.warehouse;
		// 	this.pageNo = this.totalPage = 0;
		// 	if (this.user_type == 'client_user') {
		// 		this.getMerchantList();
		// 	}
		// 	if (this.warehouseid) {
		// 		if (this.clientid) {
		// 			//this.getSalesChannels();
		// 			// console.log(this.warehouse);
		// 			// this.getOrderListReport();
		// 		} else {
		// 			this.getClientList();
		// 		}
		// 	}
		// },

		viewRackDetails(moveorderid) {
			var userToken = window.localStorage.getItem('userToken');
			var myStr = userToken.replace(/"/g, '');
			this.showOrderAllocationRacks = true;
			this.isLoading = true;

			if (localStorage.getItem('selectedClient') == '') {
				this.ClientErr = this.$t('common.clientError');
				return false;
			}
			axios({
				method: 'POST',
				'url': apiUrl.api_url + 'getMoveOrderAllocationRackDetails',
				'data': {
					clientid: localStorage.getItem('selectedClient'),
					moveorderid: moveorderid,
					warehouseid: localStorage.getItem('selectedWarehouse')
				},
				headers: {
					'Authorization': 'Bearer ' + myStr,
				}
			})
				.then(result => {
					this.allocationResultData = result.data.data;
					this.isLoading = false;
				}, error => {
					console.error(error);
				});
		},

		getMoveOrderListSearch(csvCheck) {
			this.currentPage = 1;
			this.getMoveOrderListReport(2);
		},
		getMoveOrderListReport(csvCheck = 0) {
			//console.log("ram")
			var userToken = window.localStorage.getItem('userToken');
			var myStr = userToken.replace(/"/g, '');
			if (csvCheck == 2) {
				this.show = false;
				this.download = true;
			}
			if (csvCheck == 2) {
				this.limitExeed = false
			}
			if (localStorage.getItem("selectedClient") == 'undefined' || localStorage.getItem("selectedClient") =='') {
				this.$alertify.error(this.$t('common.clientError'))
				this.pageNo = this.totalPage = 0;
				this.listOrderReportData = {
					ordercount: 0,
					totalsku: 0,
					totalquantity: 0,
					result: [],
				};

				return false;
			}
			if (localStorage.getItem("selectedWarehouse") == 'undefined' || localStorage.getItem("selectedWarehouse")=='') {
				this.$alertify.error(this.$t('common.warehouseError'))
				this.pageNo = this.totalPage = 0;
				this.listOrderReportData = {
					ordercount: 0,
					totalsku: 0,
					totalquantity: 0,
					result: [],
				};
				console.log("here")
				return false;
			}
			// if (action == 1)
			//   this.pageNo = this.totalPage = 0;
			var fromdate = '';
			var todate = '';
			var fromdateship = '';
			var todateship = '';
			var dataFilter = {};

			if (this.fromDateFlt != null && this.fromDateFlt != "") {
				fromdate = this.dateFormat(this.fromDateFlt) + " 00:00:00";
			}
			if (this.toDateFlt != null && this.toDateFlt != "") {
				todate = this.dateFormat(this.toDateFlt) + " 23:59:59";
			}



			this.isLoading = true;

			this.input = ({
				offset: (this.currentPage - 1) * 10,
				limit: this.pageLimit,
				orderStatus: this.orderStatus,
				warehouseid: localStorage.getItem('selectedWarehouse'),
				clientid: localStorage.getItem('selectedClient'),
				fromDateFlt: fromdate,
				toDateFlt: todate,
				racktype: this.racktype,
				moveorderid: this.movenoFlt.trim(),
				csvData: csvCheck,
				userid: this.userid,
				merchantid: this.merchant,
			});
			Object.entries(this.input).forEach(([k, v]) => {
				let skipkeys = ['offset', 'limit', 'csvData'];
				if (v != null && v != '' && skipkeys.indexOf(k) == -1) {
					dataFilter[k] = v;
				}
			})
			//console.log("sagar")
			axios({
				method: 'POST',
				'url': apiUrl.api_url + 'moveorderListPendingRecord',
				'data': this.input,
				headers: {
					'Authorization': 'Bearer ' + myStr,
				}
			})
				.then(result => {
					if (csvCheck == 1) {
						if (result.data.totalRows) {
							this.show = true;
							this.download = false;
							this.listOrderReportDataCsv = [];
							var skipFilter = [];
							if (this.orderStatus == 'allocated') {
								this.csvFields = {
									'moveorderid':  this.$t('common.moveOrderId'),
									'totalitem': this.$t('editedjson.totalItem'),
									'totalquantity': this.$t('common.totalQuantity'),
									'movedate': this.$t('pickPendingMoveOrder.table.columns.moveDate'),
									'racktype': this.$t('pickPendingMoveOrder.table.columns.rackType') ,
									'creationdate': this.$t('stockTransfer.creationDate'),
									'pickuserid': this.$t('editedjson.pickUserId'),
									'assigneddate': this.$t('editedjson.userAssignDate'),
									'status': this.$t('common.status'),
									'merchantname': this.$t('common.merchantName'),
								};
								var dateFilter = [];

							}
							if (this.orderStatus == 'picked') {
								this.csvFields = {
									'boxid':  this.$t('common.boxId'),
									'orderid':  this.$t('common.orderID'),
									'creationdate':  this.$t('stockTransfer.creationDate'),
									'movedate':  this.$t('pickPendingMoveOrder.table.columns.moveDate'),
									'lastmodifiedby':this.$t('orders.lastModifiedBy'),
									'lastmodifieddate': this.$t('purchaseOrder.lastModifiedDate'),
									'racktype':this.$t ('warehouseRacks.rackType'),
									'moveorderid': this.$t ('editedjson.moveorderId'),
									'pickdonedate': this.$t ('editedjson.pickDoneDate'),
									'totalitem': this.$t('common.sku'),
									'totalquantity': this.$t('stockTransfer.totalQty'),
									'merchantname': this.$t('common.merchantName'),

								};
								var dateFilter = [];

							}
							//['creationdate', 'pickdonedate', 'lastmodifieddate', 'userassigndate', 'shipbydate', 'modifieddatetime', 'orderdate', 'dateFormcreateddatetime', 'createddatetime'];

							this.listOrderReportDataCsv = result.data.result;
							csvHelper.data.jsonToCSV(this.$t('editedjson.moveOrder'), this.listOrderReportDataCsv, this.csvFields, dateFilter, skipFilter, dataFilter);

							// this.jsonToCSV('order', this.listOrderReportDataCsv, this.csvFields, dateFilter, skipFilter);
						} else {
							this.$alertify.success(this.$t('common.reportSizeError'));
						}
					} else {
						this.listOrderReportData = result.data;
						this.totalRows = result.data.totalRows;
						if (Number(this.totalRows) > Number(this.recordLimit)) {
							this.limitExeed = true
						}
						if (this.totalRows == undefined) {
							this.totalRows = 0;
						}
						if (this.totalRows < this.pageLimit) {
							this.totalPage = 1;
						} else {
							this.totalPage = Math.ceil(this.totalRows / this.pageLimit);
						}
					}
					this.isLoading = false;
				}, error => {
					console.error(error)
					this.isLoading = false;
				});
		},
		getMoveOrderListReportXLS(csvCheck = 0) {

			var userToken = window.localStorage.getItem('userToken');
			var myStr = userToken.replace(/"/g, '');
			this.show = true;
			this.download = false;
			this.dataFilter2 = [];
			var value = '';
			var str = '';

			var fromdate = '';
			var todate = '';
			var fromdateship = '';
			var todateship = '';
			var dataFilter = {};

			if (this.fromDateFlt != null && this.fromDateFlt != "") {
				fromdate = this.dateFormat(this.fromDateFlt) + " 00:00:00";
			}
			if (this.toDateFlt != null && this.toDateFlt != "") {
				todate = this.dateFormat(this.toDateFlt) + " 23:59:59";
			}




			this.input = ({
				offset: (this.currentPage - 1) * 10,
				limit: this.pageLimit,
				orderStatus: this.orderStatus,
				warehouseid: localStorage.getItem('selectedWarehouse'),
				clientid: localStorage.getItem('selectedClient'),
				fromDateFlt: fromdate,
				toDateFlt: todate,
				racktype: this.racktype,
				moveorderid: this.movenoFlt.trim(),
				csvData: csvCheck,
				userid: this.userid,
				merchantid: this.merchant
			});
			Object.entries(this.input).forEach(([k, v]) => {
				let skipkeys = ['offset', 'limit', 'csvData'];
				if (v != null && v != '' && skipkeys.indexOf(k) == -1) {
					value += k + ':' + v + ','
					this.dataFilter2 = str.concat(value);

				}
			})
			axios({
				method: 'POST',
				'url': apiUrl.api_url + 'moveorderListPendingRecord',
				'data': this.input,
				headers: {
					'Authorization': 'Bearer ' + myStr,
				}
			})
				.then(result => {
					if (csvCheck == 3) {
						if (result.data.totalRows) {
							this.listReportDataforxls = [];
							var skipFilter = [];
							if (this.orderStatus == 'allocated') {
								this.csvFieldsForXls =[];
								this.csvFieldsForXls[ this.$t('common.moveOrderId')] =  'moveorderid',
								this.csvFieldsForXls[ this.$t('editedjson.totalItem')] =  'totalitem',
								this.csvFieldsForXls[ this.$t('common.totalQuantity')] ='totalquantity',
								this.csvFieldsForXls[ this.$t('pickPendingMoveOrder.table.columns.moveDate')] = 'movedate',
								this.csvFieldsForXls[ this.$t('pickPendingMoveOrder.table.columns.rackType')] = 'racktype',
								this.csvFieldsForXls[ this.$t('stockTransfer.creationDate')] ='creationdate',
								this.csvFieldsForXls[ this.$t('editedjson.pickUserId')] = 'pickuserid',
								this.csvFieldsForXls[ this.$t('editedjson.userAssignDate')] = 'assigneddate',
								this.csvFieldsForXls[ this.$t('common.status')] =  'status',
								this.csvFieldsForXls[ this.$t('common.merchantName')] = 'merchantname'


							}
							if (this.orderStatus == 'picked') {
								this.csvFieldsForXls =[];
								this.csvFieldsForXls[ this.$t('common.moveOrderId')] =  'moveorderid',
								this.csvFieldsForXls[ this.$t('common.boxId')] = 'boxid',
								this.csvFieldsForXls[ this.$t('pickPendingMoveOrder.table.columns.moveDate')] = 'movedate',
								this.csvFieldsForXls[ this.$t('stockTransfer.creationDate')] ='creationdate',
								this.csvFieldsForXls[ this.$t('orders.lastModifiedBy')] = 'lastmodifiedby',
								this.csvFieldsForXls[ this.$t('purchaseOrder.lastModifiedDate')] = 'lastmodifieddate',
								this.csvFieldsForXls[ this.$t('warehouseRacks.rackType')] = 'racktype',
								this.csvFieldsForXls[ this.$t('editedjson.pickDoneDate')] ='pickdonedate',
								this.csvFieldsForXls[ this.$t('common.sku')] ='totalitem',
								this.csvFieldsForXls[ this.$t('stockTransfer.totalQty')] = 'totalquantity',
								this.csvFieldsForXls[ this.$t('common.merchantName')] = 'merchantname'


							}


							this.listReportDataforxls = result.data.result;


							// this.jsonToCSV('order', this.listOrderReportDataCsv, this.csvFields, dateFilter, skipFilter);
						} else {
							this.$alertify.success(this.$t('common.reportSizeError'));
						}


					}


				}, error => {
					console.error(error)
					this.isLoading = false;
				});
		},
		// getPaginationData(currentPage) {
		// 	this.pageNo = (currentPage - 1) * this.perPage
		// 	this.getOrderListReport()
		// },
		onPageChange(page) {
			this.currentPage = page;
			this.getMoveOrderListReport()
		},
		loadOrderReport(status) {
			this.listOrderReportData = {
				ordercount: 0,
				totalsku: 0,
				totalquantity: 0,
				result: [],
			};
			this.calldateFunction();
			this.item = {
				value: '',
				text: ''
			};
			// this.listMerchantData1 = [{
			// 	value: '',
			// 	text: this.$t('common.merchantPlaceholder')
			// }];
			this.totalRows = 0;
			this.orderStatus = status;
			this.pageNo = this.totalPage = 0;
			this.movenoFlt = '';
			this.searchchannel = '';
			//this.fromDateFlt = '';
			//this.toDateFlt = '';
			this.fromDateFltShip = '';
			this.toDateFltShip = '';
			this.racktype = '';
			this.ordersubtype = '';
			if (this.user_type == 'warehouse_user')
				this.client = '';
			else if (this.user_type == 'client_user')
				this.warehouse = '';
			else {
				this.client = '';
				this.warehouse = '';
			}
		},

		resetOrderSerach() {
			this.item = {
				value: '',
				text: ''
			};
			// this.listMerchantData1 = [{
			// 	value: '',
			// 	text: this.$t('common.merchantPlaceholder')
			// }];
			this.show = false;
			this.download = true;
			this.listOrderReportData = {
				ordercount: 0,
				totalsku: 0,
				totalquantity: 0,
				result: [],
			};
			this.totalRows = 0;

			this.pageNo = this.totalPage = 0;
			this.movenoFlt = '';
			document.getElementById("movenoFlt").value = "";
			this.searchchannel = '';
			this.fromDateFlt = '';
			this.toDateFlt = '';
			this.fromDateFltShip = '';
			this.toDateFltShip = '';
			this.racktype = '';
			this.ordersubtype = '';
			// this.listMerchantData = [];
			this.merchant = ''
			if (this.user_type == 'warehouse_user')
				this.client = '';
			else if (this.user_type == 'client_user')
				this.warehouse = '';
			else {
				this.client = '';
				this.warehouse = '';
			}
		},

		//validate all form fields on onsubmit()
		onSubmit: function () {
			this.$validator.validateAll().then(() => { }).catch(() => { });
		},
	} // end methods

}



// WEBPACK FOOTER //
// ./src/views/components/reports/pickPendingMoveorder/pickPendingMoveorder.component.js